export default __webpack_public_path__ + "static/twg_logo-1741379158975756c48c8fe257ec7576.svg";